export default function (field, confirmfield) {
  if (field === confirmfield) {
    return { error: false, typeError: "" };
  } else {
    return { error: true, typeError: "Os campos estão diferentes!" };
  }
}
